import { FC, SVGAttributes, useId } from 'react';
import { StarSvg } from './styles';

export type StarFill = 'empty' | 'half' | 'full';

export interface StarProps extends Omit<SVGAttributes<SVGSVGElement>, 'fill'> {
  fill?: StarFill;
}

const STAR_PATH =
  'M7.95801 4.66016L8.10449 5.00684L8.47949 5.03906L11.8076 5.32812L9.29102 7.51074L9.00586 7.75781L9.09082 8.12402L9.8418 11.3682L6.98926 9.64844L6.66699 9.45312L6.34375 9.64844L3.49121 11.3682L4.24219 8.12402L4.32715 7.75781L4.04297 7.51074L1.52441 5.32812L4.85449 5.03906L5.22949 5.00684L5.37598 4.66016L6.66602 1.60449L7.95801 4.66016Z';

const Star: FC<StarProps> = ({ fill = 'empty', ...rest }) => {
  const rawId = useId();
  const gradientId = `seed-star-half-${rawId.replace(/:/g, '')}`;

  return (
    <StarSvg
      $fill={fill}
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden={true}
      {...rest}
    >
      {fill === 'half' && (
        <defs>
          <linearGradient id={gradientId} x1='0' y1='0' x2='1' y2='0'>
            <stop offset='50%' className='star-fill-stop' />
            <stop offset='50%' className='star-fill-stop-transparent' />
          </linearGradient>
        </defs>
      )}
      <g transform='translate(1.3333 1.3333)'>
        <path
          d={STAR_PATH}
          className={
            fill === 'empty'
              ? 'star-outline'
              : fill === 'half'
                ? 'star-half'
                : 'star-fill'
          }
          fill={fill === 'half' ? `url(#${gradientId})` : undefined}
          strokeWidth={1.25}
          strokeLinejoin='miter'
        />
      </g>
    </StarSvg>
  );
};

export default Star;
